// 引入
import { createStore } from "vuex";
import serviceProvider from "../services/service-provider"
import messageService from '../services/message.service'

export default createStore({
    // 声明变量
    state: {
        isDark: localStorage.getItem("tw_design_theme")?.indexOf('dark') > -1 
        || localStorage.getItem("tw_design_theme")?.indexOf('vela') > -1 
        || localStorage.getItem("tw_design_theme")?.indexOf('arya') > -1 
        || localStorage.getItem("tw_design_theme")?.indexOf('kuna') > -1,

        activeSubmenus: []
    },
    mutations: {
        // 参数一：state，参数二：新值
        setDark(state, val){
            state.isDark = val
        },
        setActiveSubmenus(state, items) {
            const menu = [];

            items?.filter(el => el.type === 'folder' || serviceProvider?.userService.isPower(el.id)).forEach(el => {
                menu.push({
                    label: el.label,
                    file_name: el.file_name,
                    icon: el.icon,
                    visible: el.visible,
                    items: el.children,
                    type: el.type,
                    command: (event) => {
                        switch (event.item.type) {
                            case 'page':
                                if (el?.file_name) {
                                    serviceProvider.windowService.openPage(el.file_name)
                                } else {
                                    messageService.info({
                                        showClose: true,
                                        message: '此项未配置页面！'
                                    })
                                }
                                break;
                            case 'link':
                                if (el?.url) {
                                    window.open(el.url)
                                } else {
                                    messageService.info({
                                        showClose: true,
                                        message: '此项未配置外链地址！'
                                    })
                                }
                                break;
                            default:
                                messageService.info({
                                    showClose: true,
                                    message: `不可识别的页面类型 ${el.type}！`
                                })
                                break;
                        }
                    }
                })
            })

            state.activeSubmenus = menu
        }
    },
    modules: {

    }
});